import { Pencil, Trash2 } from "lucide-react";
import Button from "../../common/components/Button";
import PrimaryButton from "../../common/components/PrimaryButton";
import { useCallback, useState } from "react";
import DeleteModal from "../../common/components/DeleteModal";
import { getDefaultAction } from "../../common/helpers/common";
import PageForm from "./PageForm";

function Pages({
  action,
  setAction,
  pages,
  refetch,
  isOwner,
  onDelete,
  isDeleting,
  onClose,
}) {
  const { pageId, pageName } = action?.data || {};

  return (
    <div className="text-gray-700">
      <div className="flex justify-between items-center mb-8">
        <div className="text-2xl font-bold">Pages</div>
        {isOwner ? (
          <PrimaryButton
            btnCls="!w-fit"
            buttonProps={{
              onClick: () => setAction({ type: "Create", isOpen: true }),
            }}
          >
            + Create Page
          </PrimaryButton>
        ) : null}
      </div>

      {pages?.length ? (
        <div className="flex flex-wrap gap-4">
          {pages?.map((page, i) => {
            const { name, _id } = page;

            const data = {
              pageId: _id,
              pageName: name,
            };

            return (
              <div
                key={i}
                className="px-4 py-4 min-w-48 bg-white rounded-md border border-gray-300 flex items-center justify-between"
              >
                <div className="mr-4">{name}</div>

                {isOwner ? (
                  <div className="flex items-center">
                    <Button
                      buttonProps={{
                        className:
                          "hover:bg-gray-100 rounded-md p-2 hover:text-blue-600",
                        onClick: () => {
                          setAction({
                            type: "Edit",
                            isOpen: true,
                            data,
                          });
                        },
                      }}
                    >
                      <Pencil size={20} />
                    </Button>

                    <Button
                      buttonProps={{
                        className:
                          "hover:bg-gray-100 rounded-md p-2 hover:text-red-600",
                        onClick: () => {
                          setAction({
                            type: "Delete",
                            isOpen: true,
                            data,
                          });
                        },
                      }}
                    >
                      <Trash2 size={20} />
                    </Button>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-gray-500  text-lg">
          Pages not found
        </div>
      )}

      <PageForm
        title={`${action.type} Page`}
        open={["Create", "Edit"].includes(action.type) && action.isOpen}
        setOpen={onClose}
        onSuccess={refetch}
        pageId={pageId}
        pageName={pageName}
      />

      <DeleteModal
        title={`Are you sure, you want to delete this page (${pageName})?`}
        open={action.type === "Delete"}
        setOpen={onClose}
        onDelete={() => onDelete(pageId)}
        isDeleting={isDeleting}
      />
    </div>
  );
}

export default Pages;
